import styled from "styled-components";

const Container = styled.div`
  display: flex;
  justify-content: center;
  gap: 6px;
  flex-wrap: wrap;

  > * {
    font-size: 10px;
    color: ${({ theme }) => theme.colors.navBarIcons};
  }
`;

export { Container };